import * as Sentry from '@sentry/angular';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from 'environments/environment';

if (environment.production && environment.sentry) {
  Sentry.init({
    enabled: environment.production,
    dsn: environment.sentry,
    sendDefaultPii: true,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 0.5,
    tracePropagationTargets: [environment.apiUrl],
    enableLogs: false,
    release: environment.version,
  });
}

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
